import { render, staticRenderFns } from "./Cierre.vue?vue&type=template&id=15ce00c0&"
import script from "./Cierre.vue?vue&type=script&lang=js&"
export * from "./Cierre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports